import type { OrganizationDto } from 'src/hooks/useOrganizations'

// Picks the workspace to make active: last-used (if the user is still a
// member) -> first team -> personal. Kept dependency-free so it stays unit
// testable without pulling in the Vite/axios module graph.
export function resolveActiveOrgId(
  orgs: OrganizationDto[],
  stored: string | null,
): string | null {
  if (stored !== null && orgs.some((org) => org.id === stored)) {
    return stored
  }
  const firstTeam = orgs.find((org) => org.personalForUserId === null)
  if (firstTeam) {
    return firstTeam.id
  }
  const personal = orgs.find((org) => org.personalForUserId !== null)
  return personal?.id ?? null
}
